// components

// react
import { useEffect, useState } from 'react';
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import { BeatLoader } from 'react-spinners';

// kendo
import kendo from "@progress/kendo-ui";

// css
import styles from './userMonitor_mobile.module.css';
import './userMonitor_mobile.css'

// services
import { numFormat } from './../../../com/dataUtil';
import { authGuest, setDelToken, setToken, getUser, isUser } from "../../../service/authService";
import { getData } from './../../../service/mobile/userInfoService';
import UserMonitorGridMobile from './userMonitorGrid_mobile';
import UserMonitorChartMobile from './userMonitorChart_mobile';

// library
import moment from "moment";
import "moment/locale/ko"; // 한국어 locale 불러오기

function UserMonitorMobile({conn, setUpdateLoginStatus, loginStatus}) {

  moment.locale("ko"); // 한국어 locale 설정

  const locationState = useLocation().state;
  
  const [loading, setLoading] = useState(false);

  // 날짜 Default 정의
  let today = new Date();
  let yesterday = new Date();
  let lastWeek = new Date();
  let lastMonth = new Date();
  let lastYear = new Date();
  yesterday.setDate(today.getDate() - 1);
  lastWeek.setDate(yesterday.getDate() - 7);
  lastMonth.setDate(yesterday.getDate() - 30);
  lastYear.setDate(yesterday.getDate() - 365);
  // 오늘 날짜 비교 변수
  const date = kendo.toString(today, "yyyy-MM-dd");
  
  const [search, setSearch] = useState({
    dateType: "HH",
    dataType: locationState.dataType,
    cid: locationState.cid,
    startDtm: new Date(),
    endDtm: new Date(),
  })

  const [dataSource, setDataSource] = useState({
    datalist: [],
    chartTimeList: [],
    movement: [],
    temperature: [],
    humidity: [],
    co2: [],
    light: [],
    velocityTotal: [],
    avg: 0,
  });

  // 날짜 선택 버튼 색 변경
  const [selectDateColor, setSelectDateColor] = useState({
    dayColor: "#fff",
    weekColor: "#a4a4a4",
    monthColor: "#a4a4a4",
    dayBackground: "#5e9dd4",
    weekBackground: "#fff",
    monthBackground: "#fff",
  })

  // 날짜 범위 변경
  const changeDateRange = (e) => {
    if(e.target.id === "day") {
      setSearch(search => {
        const item = { ...search };
        item.dateType = "HH";
        item.startDtm = today;
        item.endDtm = today;
        setDataList(item);
        return item;
      })
      // search.dateType = "HH";
      // setDataList();
    } else if(e.target.id === "week") {
      setSearch(search => {
        const item = { ...search };
        item.dateType = "DD";
        item.startDtm = new Date(today.getTime() - (6 * 24 * 60 * 60 * 1000));
        item.endDtm = today;
        setDataList(item);
        return item;
      })
      // search.dateType = "DD";
      // setDataList();
    } else if(e.target.id === "month") {
      setSearch(search => {
        const item = { ...search };
        item.dateType = "MM";
        item.startDtm = new Date(today.getFullYear(), today.getMonth(), 1);
        item.endDtm = today;
        setDataList(item);
        return item;
      })
      // search.dateType = "MM";
      // setDataList();
    } else {
      return;
    }


    // 버튼 색상 변경
    if(e.currentTarget.id === "day") {
      setSelectDateColor(selectDateColor => {
        const item = { ...selectDateColor};
        item.dayColor = "#fff"
        item.weekColor = "#a4a4a4"
        item.monthColor = "#a4a4a4"
        item.dayBackground = "#5e9dd4"
        item.weekBackground = "#fff"
        item.monthBackground = "#fff"
        return item;
      })
    } else if(e.currentTarget.id === "week") {
      setSelectDateColor(selectDateColor => {
        const item = { ...selectDateColor};
        item.dayColor = "#a4a4a4"
        item.weekColor = "#fff"
        item.monthColor = "#a4a4a4"
        item.dayBackground = "#fff"
        item.weekBackground = "#5e9dd4"
        item.monthBackground = "#fff"
        return item;
      })
    } else if(e.currentTarget.id === "month") {
      setSelectDateColor(selectDateColor => {
        const item = { ...selectDateColor};
        item.dayColor = "#a4a4a4"
        item.weekColor = "#a4a4a4"
        item.monthColor = "#fff"
        item.dayBackground = "#fff"
        item.weekBackground = "#fff"
        item.monthBackground = "#5e9dd4"
        return item;
      })
    }
  }

  // 날짜 변경
  const changeDate = (e) => {
    if(search.dateType === "MM") {
      if(e.target.id === "before") {
        // 현재 날짜 기준 지난달 데이터 검색
        search.startDtm = new Date(search.startDtm.getFullYear(), search.startDtm.getMonth() - 1, 1);
        search.endDtm = new Date(search.endDtm.getFullYear(), search.endDtm.getMonth(), 0);
        setDataList(search);
      } else if(e.target.id === "after") {
        // 현재 날짜 기준 다음달 데이터 검색
        if(search.endDtm.getMonth() === today.getMonth() - 1) {
          search.startDtm = new Date(search.startDtm.getFullYear(), search.startDtm.getMonth() + 1, 1);
          search.endDtm = today;
        } else {
          search.startDtm = new Date(search.startDtm.getFullYear(), search.startDtm.getMonth() + 1, 1);
          search.endDtm = new Date(search.endDtm.getFullYear(), search.endDtm.getMonth() + 2, 0);
        }
        setDataList(search);
      } else {
        return;
      }
    } else {
      if(e.target.id === "before") {
        // 현재 날짜 기준 -1일 데이터 검색
        search.startDtm.setDate(search.startDtm.getDate()-1);
        search.endDtm.setDate(search.endDtm.getDate()-1);
        setDataList(search);
      } else if(e.target.id === "after") {
        // 현재 날짜 기준 +1일 데이터 검색
        search.startDtm.setDate(search.startDtm.getDate()+1);
        search.endDtm.setDate(search.endDtm.getDate()+1);
        setDataList(search);
      } else {
        return;
      }
    }
  }
  
  // 평균값 데이터 단위 표시
  const avgUnit = () => {
    if(search.dataType === "movement" || search.dataType === "velocityTotal") {
      return null;
    } else if(search.dataType === "temperature") {
      return "°C";
    } else if(search.dataType === "humidity") {
      return "%";
    } else if(search.dataType === "co2") {
      return "ppm";
    } else if(search.dataType === "light") {
      return "Lx";
    } else {
      return null;
    }
  }

  // 배열 합 구하는 함수
  const sum = (array) => {
    let total = 0;
    for (let i = 0; i < array.length; i++) {
      total += array[i];
    }
    return total;
  }

  const setDataList = (data) => {  
    setLoading(true);
    getData(conn, getDataList, getRejection, data);
  };

  const getDataList = (response) => {
    // 평균값 구하기
    if(search.dataType === "movement") {
      dataSource.avg = numFormat(Math.round(sum(response.movement.map(({y}) => y))/response.movement.length))
    } else if(search.dataType === "temperature") {
      dataSource.avg = numFormat(Math.round(sum(response.temperature.map(({y}) => y))/response.temperature.length))
    } else if(search.dataType === "humidity") {
      dataSource.avg = numFormat(Math.round(sum(response.humidity.map(({y}) => y))/response.humidity.length))
    } else if(search.dataType === "co2") {
      dataSource.avg = numFormat(Math.round(sum(response.co2.map(({y}) => y))/response.co2.length))
    } else if(search.dataType === "light") {
      dataSource.avg = numFormat(Math.round(sum(response.light.map(({y}) => y))/response.light.length))
    } else if(search.dataType === "velocityTotal") {
      dataSource.avg = numFormat(Math.round(sum(response.velocityTotal.map(({y}) => y))/response.velocityTotal.length))
    } else {

    }
    setDataSource(dataSource => {
      const item = { ...dataSource }
      item.datalist = response.data;
      item.movement = response.movement;
      item.temperature = response.temperature;
      item.humidity = response.humidity;
      item.co2 = response.co2;
      item.light = response.light;
      item.velocityTotal = response.velocityTotal;
      return item;
    });
    setLoading(false);
  }

  const getRejection = error => {
    console.error("getDataList error = ", error);
  };

  useEffect(() => {
    setDataList(search);
  },[])

  return (
    <>
      <div className="pageContent_m">
        <div className="userMonitorSelectDate">
          <button style={{color: selectDateColor.dayColor, backgroundColor:selectDateColor.dayBackground}} className="selectDateBtn" id="day" onClick={changeDateRange}>
            1일
          </button>
          <button style={{color: selectDateColor.weekColor, backgroundColor:selectDateColor.weekBackground}} className="selectDateBtn" id="week" onClick={changeDateRange}>
            1주
          </button>
          <button style={{color: selectDateColor.monthColor, backgroundColor:selectDateColor.monthBackground}} className="selectDateBtn" id="month" onClick={changeDateRange}>
            1개월
          </button>
        </div>
        <div className="userMonitorDataAvg">
          <span className="avgText">평균</span><span className="avgValue">{dataSource.avg === "NaN" ? "-" : dataSource.avg}</span><span className="avgText">{avgUnit()}</span>
        </div>
        <div className="userMonitorChangeDate">
          <img className="changeDateImg" id="before" src="/images/mobile/date_back.png" onClick={changeDate}></img>  
          {
            search.dateType === "HH" ? <span className="changeDateText">{kendo.toString(search.endDtm, 'yyyy년 MM월 dd일')}</span>
            : search.dateType === "DD" ? <span className="changeDateText">{kendo.toString(search.startDtm, 'yy년 MM월 dd일')} ~ {kendo.toString(search.endDtm, 'yy년 MM월 dd일')}</span>
            : search.dateType === "MM" ? <span className="changeDateText">{kendo.toString(search.startDtm, 'yy년 MM월 dd일')} ~ {kendo.toString(search.endDtm, 'yy년 MM월 dd일')}</span>
            : null
          }
          {
            kendo.toString(search.endDtm, "yyyy-MM-dd") === date ?
            <img className="changeDateImg" id="after" src="/images/mobile/date_forward.png" style={{opacity: "0.3"}}></img>
            :
            <img className="changeDateImg" id="after" src="/images/mobile/date_forward.png" onClick={changeDate}></img>
          }
        </div>
        <div className="userMonitorChart">
          <UserMonitorChartMobile
            dataSource={dataSource}
            search={search}>
          </UserMonitorChartMobile>
        </div>
        <div className="userMonitorGrid">
          <UserMonitorGridMobile 
            dataSource={dataSource}
            search={search}>
          </UserMonitorGridMobile>
        </div>
      </div>
      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={18} color="#5e9dd4" />
        </p>
      )}
    </>
  );
}

export default UserMonitorMobile;
